/*
 * Copyright © 2018, Rezo Zero
 *
 * @file AbstractPage.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import { AbstractPage } from 'starting-blocks'
import { $window } from '../utils/environment'
import * as Utils from '../utils/Utils'

export default class Page extends AbstractPage {
    constructor (router, container, context, type) {
        super(router, container, context, type)

        this.locked = false

        this.dashlines = this.$cont.find('.dashline-color-change')

        // Binded methods
        this.onBeforePageShow = this.onBeforePageShow.bind(this)
        this.onTransitionComplete = this.onTransitionComplete.bind(this)
        this.onInViewScroll = this.onInViewScroll.bind(this)
        this.onBubbleManagerSetup = this.onBubbleManagerSetup.bind(this)
    }

    init () {
        super.init()

        if (this.context === 'static') {
            this.staticLoad()
        }

        this.braillify()
    }

    braillify () {
        if (Utils.isMobile()) return

        const $els = this.$cont.find('.braillify')

        if (!$els || !$els.length) return

        const splitText = new window.SplitText($els, { type: 'chars' })

        /**
         * @type {Array<HTMLElement>}
         */
        const chars = splitText.chars

        for (let char of chars) {
            char.innerHTML = `
                <span class="regular">${char.innerHTML}</span>
                <span class="braille">${char.innerHTML}</span>
            `
            char.classList.add('braille-wrap')
        }
    }

    setLocked (value) {
        this.locked = value
    }

    scrollInitiated () {}

    staticLoad () {}

    changeColors () {
        this.dashlines.toggleClass('dashline-black').toggleClass('dashline-white')
    }

    initEvents () {
        super.initEvents()

        window.addEventListener('SB_BEFORE_PAGE_SHOW', this.onBeforePageShow)
        window.addEventListener('SB_TRANSITION_COMPLETE', this.onTransitionComplete)
        $window.on('bubbleManager.setup', this.onBubbleManagerSetup)

        $window.on('inview.Scroll', this.onInViewScroll)
    }

    destroyEvents () {
        super.destroyEvents()

        window.removeEventListener('SB_BEFORE_PAGE_SHOW', this.onBeforePageShow)
        window.removeEventListener('SB_TRANSITION_COMPLETE', this.onTransitionComplete)
        $window.off('bubbleManager.setup', this.onBubbleManagerSetup)

        $window.off('inview.Scroll', this.onInViewScroll)
    }

    onBubbleManagerSetup () {}

    onInViewScroll (e) {}

    onTransitionComplete () {
        this.transitionComplete()
        for (let block of this.blocks) {
            block.onTransitionComplete()
        }
    }

    onBeforePageShow () {
        this.beforePageShow()
    }

    transitionComplete () {}

    beforePageShow () {}

    onLazyImageProcessed (index) {
        super.onLazyImageProcessed()
    }

    onResize () {
        super.onResize()
    }

    onLazyImageSet (element) {}

    onLazyImageLoad (element) {
        $window.triggerHandler('LazyImageLoad')
    }
}



// WEBPACK FOOTER //
// ./webpack/js/pages/Page.js